var _a;
import { DialogBalloonOffer } from "../balloon/DialogBalloonOffer";
import { DialogCharacterHelp } from "../character-help-dialog/DialogCharacterHelp";
import { DialogMaintenance } from "../client-gateway/DialogMaintenance";
import { DialogManualUpdate } from "../client-gateway/DialogManualUpdate";
import { DialogCooperativeLevelUp } from "../cooperative/DialogCooperativeLevelUp";
import { DialogCoopLanguageFilter } from "../cooperative/DialogCoopLanguageFilter";
import { DialogCoopLeaveConfirm } from "../cooperative/DialogCoopLeaveConfirm";
import { DialogCoopRoleManagement } from "../cooperative/DialogCoopRoleManagement";
import { DialogDemoteLeaderConfirm } from "../cooperative/DialogDemoteLeaderConfirm";
import { DialogCoopInvitation } from "../cooperative/DialogInvitation";
import { DialogCoopInvite } from "../cooperative/DialogInvite";
import { DialogCoopKick } from "../cooperative/DialogKick";
import { MenuCoop } from "../cooperative/MenuCoop";
import { DialogCoopProjectCompleted } from "../cooperative/projects/DialogCoopProjectCompleted";
import { DialogCoopProjectStartConfirmation } from "../cooperative/projects/DialogCoopProjectStartConfirmation";
import { DialogCoopProjectStopConfirmation } from "../cooperative/projects/DialogCoopProjectStopConfirmation";
import { DialogDisconnect } from "../disconnect-dialog/DialogDisconnect";
import { DialogDiscountEvent } from "../discount-event/DialogDiscountEvent";
import { DialogCollectRewardsDogTreat } from "../doghouse/DialogCollectRewardsDogTreat";
import { DialogDogHouseInfo } from "../doghouse/DialogDogHouseInfo";
import { DialogDoghouseShowAllRewards } from "../doghouse/DialogDoghouseShowAllRewards";
import { MenuDoghouse } from "../doghouse/MenuDoghouse";
import { DialogEnvSelect } from "../env-select/DialogEnvSelect";
import { DialogExternalBarnInfo } from "../external-barn/DialogExternalBarnInfo";
import { MenuExternalBarnUpgrade } from "../external-barn/MenuExternalBarnUpgrade";
import { DialogFacebookAnotherPlayerConnect } from "../facebook/DialogFacebookAnotherPlayerConnect";
import { DialogFacebookAnotherPlayerConnected } from "../facebook/DialogFacebookAnotherPlayerConnected";
import { DialogFacebookAnotherPlayerLogout } from "../facebook/DialogFacebookAnotherPlayerLogout";
import { DialogFacebookConnectFailure } from "../facebook/DialogFacebookConnectFailure";
import { MenuFarmManagement } from "../farm-management/MenuFarmManagement";
import { DialogFeedback } from "../feedback/DialogFeedback";
import { DialogFeedbackConfirmation } from "../feedback/DialogFeedbackConfirmation";
import { DialogCollectReward } from "../fortune-teller-event/components/DialogCollectReward";
import { DialogFortuneTellerEvent } from "../fortune-teller-event/components/DialogFortuneTellerEvent";
import { MenuInfoBuilding } from "../info-menu/MenuInfoBuilding";
import { MenuQuests } from "../info/quest/list/MenuQuests";
import { MenuLibrary } from "../library/MenuLibrary";
import { DialogLogoutConfirmation } from "../logout-dialog/DialogLogoutConfirmation";
import { MenuMarket } from "../market/MenuMarket";
import { DialogNotEnoughResource } from "../not-enough-resource/DialogNotEnoughResource";
import { MenuNursery } from "../nursery/MenuNursery";
import { DialogPendingInventory } from "../pending-inventory/DialogPendingInventory";
import { MenuBuildings } from "../player-base/buildings/MenuBuildings";
import { MenuBuildingUpgrade } from "../player-base/buildings/upgrade/MenuBuildingUpgrade";
import { MenuExpansionsPurchase } from "../player-base/expansions/MenuExpansionsPurchase";
import { DialogPlayerProfile } from "../player-profile/DialogPlayerProfile";
import { DialogSelectPlayerProfilePicture } from "../profile-picture/DialogSelectPlayerProfilePicture";
import { DialogSelectPlayerProfilePictureInfo } from "../profile-picture/DialogSelectPlayerProfilePictureInfo";
import { PromoteMobile } from "../promote-mobile/promoteMobile";
import { DialogPurchasePointsEvent } from "../purchase-points-event/components/DialogPurchasePointsEvent";
import { DialogQuestIntros } from "../quest-intros/DialogQuestIntros";
import { DialogQuickSell } from "../quick-sell-dialog/DialogQuickSell";
import { DialogQuickSkip } from "../quick-skip-dialog/DialogQuickSkip";
import { DialogRankingLanguageFilter } from "../ranking/DialogRankingLanguageFilter";
import { MenuPlayerRanking } from "../ranking/MenuPlayerRanking";
import { DialogDisconnectedByLogin } from "../reconnect-after-login/DialogDisconnectedByLogin";
import { DialogSetPlayerName } from "../set-player-name/DialogSetPlayerName";
import { MenuSettings } from "../settings/MenuSettings";
import { DialogPaymentRewards } from "../shop/components/DialogPaymentRewards";
import { DialogShopGrowingOfferInfo } from "../shop/components/DialogShopGrowingOfferInfo";
import { MenuShop } from "../shop/components/MenuShop";
import { MenuShopInterstitialOffer } from "../shop/components/MenuShopInterstitialOffer";
import { DialogSpendGoldConfirmation } from "../spend-gold-confirmation/DialogSpendGoldConfirmation";
import { DialogCollectRewardStore } from "../store/DialogCollectRewardStore";
import { DialogShowAllRewardsStore } from "../store/DialogShowAllRewardsStore";
import { MenuStore } from "../store/MenuStore";
import { DialogSunsetting } from "../sunsetting/DialogSunsetting";
import { DialogChooseDifficulty } from "../themed-events/DialogChooseDifficulty";
import { DialogThemedEventReward } from "../themed-events/DialogThemedEventReward";
import { MenuThemedEvent } from "../themed-events/MenuThemedEvent";
import { MenuCollectEvent } from "../tournament-building/collect-event/MenuCollectEvent";
import { DialogConfirmBuyTournamentSpecialOffer } from "../tournament-building/DialogConfirmBuyTournamentSpecialOffer";
import { DialogLeagueReward } from "../tournament-building/DialogLeagueReward";
import { DialogLeagueRewardSpecialOffer } from "../tournament-building/DialogLeagueRewardSpecialOffer";
import { DialogPromoteDemote } from "../tournament-building/DialogPromoteDemote";
import { MenuTournament } from "../tournament-building/MenuTournament";
import { DialogTraderEvent } from "../trader-event/components/DialogTraderEvent";
import { MenuWaterTower } from "../watertower/MenuWaterTower";
import { DialogWebExclusivePackage } from "../web-exclusive-package/DialogWebExclusivePackage";
import { MenuLevelUp } from "../xp/MenuLevelUp";
import { IdModal } from "./IdModal";
import { TypeModal } from "./TypeModal";
export var modals = (_a = {},
    // menu
    _a[IdModal.BuildingList] = {
        domComponent: MenuBuildings,
        modalId: IdModal.BuildingList,
        type: TypeModal.Menu,
    },
    _a[IdModal.Quests] = {
        domComponent: MenuQuests,
        modalId: IdModal.Quests,
        type: TypeModal.Menu,
    },
    _a[IdModal.Market] = {
        domComponent: MenuMarket,
        modalId: IdModal.Market,
        type: TypeModal.Menu,
    },
    _a[IdModal.Cooperative] = {
        domComponent: undefined,
        modalId: IdModal.Cooperative,
        type: TypeModal.Menu,
    },
    _a[IdModal.Nursery] = {
        domComponent: MenuNursery,
        modalId: IdModal.Nursery,
        type: TypeModal.Menu,
    },
    _a[IdModal.Doghouse] = {
        domComponent: MenuDoghouse,
        modalId: IdModal.Doghouse,
        type: TypeModal.Menu,
    },
    _a[IdModal.FarmManagement] = {
        domComponent: MenuFarmManagement,
        modalId: IdModal.FarmManagement,
        type: TypeModal.Menu,
    },
    _a[IdModal.Cafe] = {
        domComponent: undefined,
        modalId: IdModal.Cafe,
        type: TypeModal.Menu,
    },
    _a[IdModal.WaterTower] = {
        domComponent: MenuWaterTower,
        modalId: IdModal.WaterTower,
        type: TypeModal.Menu,
    },
    _a[IdModal.Shop] = {
        domComponent: MenuShop,
        modalId: IdModal.Shop,
        type: TypeModal.Menu,
    },
    _a[IdModal.ShopInterstitialOffer] = {
        domComponent: MenuShopInterstitialOffer,
        modalId: IdModal.ShopInterstitialOffer,
        type: TypeModal.Menu,
    },
    _a[IdModal.TournamentTent] = {
        domComponent: MenuTournament,
        modalId: IdModal.TournamentTent,
        type: TypeModal.Menu,
    },
    _a[IdModal.Library] = {
        domComponent: MenuLibrary,
        modalId: IdModal.Library,
        type: TypeModal.Menu,
    },
    _a[IdModal.PlayerRanking] = {
        domComponent: MenuPlayerRanking,
        modalId: IdModal.PlayerRanking,
        type: TypeModal.Menu,
    },
    _a[IdModal.TournamentTent] = {
        domComponent: MenuTournament,
        modalId: IdModal.TournamentTent,
        type: TypeModal.Menu,
    },
    _a[IdModal.Harbor] = {
        // TODO: add domComponent for Harbor
        modalId: IdModal.Harbor,
        type: TypeModal.Menu,
    },
    _a[IdModal.Pier] = {
        // TODO: add domComponent for Pier
        modalId: IdModal.Pier,
        type: TypeModal.Menu,
    },
    _a[IdModal.PlayerRanking] = {
        domComponent: MenuPlayerRanking,
        modalId: IdModal.PlayerRanking,
        type: TypeModal.Menu,
    },
    _a[IdModal.Settings] = {
        domComponent: MenuSettings,
        modalId: IdModal.Settings,
        type: TypeModal.Menu,
    },
    _a[IdModal.ThemedEvent] = {
        domComponent: MenuThemedEvent,
        modalId: IdModal.ThemedEvent,
        type: TypeModal.Menu,
    },
    _a[IdModal.Coop] = {
        domComponent: MenuCoop,
        modalId: IdModal.Coop,
        type: TypeModal.Menu,
    },
    _a[IdModal.TournamentTent] = {
        domComponent: MenuTournament,
        modalId: IdModal.TournamentTent,
        type: TypeModal.Menu,
    },
    _a[IdModal.ExternalBarnUpgrade] = {
        domComponent: MenuExternalBarnUpgrade,
        modalId: IdModal.ExternalBarnUpgrade,
        type: TypeModal.Menu,
    },
    _a[IdModal.Store] = {
        domComponent: MenuStore,
        modalId: IdModal.Store,
        type: TypeModal.Menu,
    },
    _a[IdModal.CollectEvent] = {
        domComponent: MenuCollectEvent,
        modalId: IdModal.CollectEvent,
        type: TypeModal.Menu,
    },
    // dialog
    _a[IdModal.PlayerProfile] = {
        domComponent: DialogPlayerProfile,
        modalId: IdModal.PlayerProfile,
        type: TypeModal.Dialog,
    },
    _a[IdModal.BuildingInfo] = {
        domComponent: MenuInfoBuilding,
        modalId: IdModal.BuildingInfo,
        type: TypeModal.Dialog,
    },
    _a[IdModal.BuildingUpgrade] = {
        domComponent: MenuBuildingUpgrade,
        modalId: IdModal.BuildingUpgrade,
        type: TypeModal.Dialog,
    },
    _a[IdModal.PurchaseExpansion] = {
        domComponent: MenuExpansionsPurchase,
        modalId: IdModal.PurchaseExpansion,
        type: TypeModal.Dialog,
    },
    _a[IdModal.LevelUp] = {
        domComponent: MenuLevelUp,
        modalId: IdModal.LevelUp,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CooperativeLevelUp] = {
        domComponent: DialogCooperativeLevelUp,
        modalId: IdModal.CooperativeLevelUp,
        type: TypeModal.Dialog,
    },
    _a[IdModal.DogTreatReward] = {
        domComponent: DialogCollectRewardsDogTreat,
        modalId: IdModal.DogTreatReward,
        type: TypeModal.Dialog,
    },
    _a[IdModal.QuickSell] = {
        domComponent: DialogQuickSell,
        modalId: IdModal.QuickSell,
        type: TypeModal.Dialog,
    },
    _a[IdModal.NotEnoughResource] = {
        domComponent: DialogNotEnoughResource,
        modalId: IdModal.NotEnoughResource,
        type: TypeModal.Dialog,
    },
    _a[IdModal.SpendGoldConfirmation] = {
        domComponent: DialogSpendGoldConfirmation,
        modalId: IdModal.SpendGoldConfirmation,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CharacterHelp] = {
        domComponent: DialogCharacterHelp,
        modalId: IdModal.CharacterHelp,
        type: TypeModal.Dialog,
    },
    _a[IdModal.SetPlayerName] = {
        domComponent: DialogSetPlayerName,
        modalId: IdModal.SetPlayerName,
        type: TypeModal.Dialog,
    },
    _a[IdModal.SkipProcess] = {
        domComponent: DialogQuickSkip,
        modalId: IdModal.SkipProcess,
        type: TypeModal.Dialog,
    },
    _a[IdModal.QuestIntros] = {
        domComponent: DialogQuestIntros,
        modalId: IdModal.QuestIntros,
        type: TypeModal.Dialog,
    },
    _a[IdModal.Feedback] = {
        domComponent: DialogFeedback,
        modalId: IdModal.Feedback,
        type: TypeModal.Dialog,
    },
    _a[IdModal.FeedbackConfirmation] = {
        domComponent: DialogFeedbackConfirmation,
        modalId: IdModal.FeedbackConfirmation,
        type: TypeModal.Dialog,
    },
    _a[IdModal.ShowAllRewards] = {
        domComponent: DialogDoghouseShowAllRewards,
        modalId: IdModal.ShowAllRewards,
        type: TypeModal.Dialog,
    },
    _a[IdModal.DoghouseInfo] = {
        domComponent: DialogDogHouseInfo,
        modalId: IdModal.DoghouseInfo,
        type: TypeModal.Dialog,
    },
    _a[IdModal.PaymentReward] = {
        domComponent: DialogPaymentRewards,
        modalId: IdModal.PaymentReward,
        type: TypeModal.Dialog,
    },
    _a[IdModal.FacebookConnectFailure] = {
        domComponent: DialogFacebookConnectFailure,
        modalId: IdModal.FacebookConnectFailure,
        type: TypeModal.Dialog,
    },
    _a[IdModal.FacebookConnectAnotherPlayerConnected] = {
        domComponent: DialogFacebookAnotherPlayerConnected,
        modalId: IdModal.FacebookConnectAnotherPlayerConnected,
        type: TypeModal.Dialog,
    },
    _a[IdModal.FacebookConnectAnotherPlayerConnect] = {
        domComponent: DialogFacebookAnotherPlayerConnect,
        modalId: IdModal.FacebookConnectAnotherPlayerConnect,
        type: TypeModal.Dialog,
    },
    _a[IdModal.FacebookConnectAnotherPlayerLogout] = {
        domComponent: DialogFacebookAnotherPlayerLogout,
        modalId: IdModal.FacebookConnectAnotherPlayerLogout,
        type: TypeModal.Dialog,
    },
    _a[IdModal.ExternalBarnInfo] = {
        domComponent: DialogExternalBarnInfo,
        modalId: IdModal.ExternalBarnInfo,
        type: TypeModal.Dialog,
    },
    _a[IdModal.LeagueReward] = {
        domComponent: DialogLeagueReward,
        modalId: IdModal.LeagueReward,
        type: TypeModal.Dialog,
    },
    _a[IdModal.RankingLanguageFilter] = {
        domComponent: DialogRankingLanguageFilter,
        modalId: IdModal.RankingLanguageFilter,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CoopLanguageFilter] = {
        domComponent: DialogCoopLanguageFilter,
        modalId: IdModal.CoopLanguageFilter,
        type: TypeModal.Dialog,
    },
    _a[IdModal.LogoutConfirmation] = {
        domComponent: DialogLogoutConfirmation,
        modalId: IdModal.LogoutConfirmation,
        type: TypeModal.Dialog,
    },
    _a[IdModal.ThemedEventDifficulty] = {
        domComponent: DialogChooseDifficulty,
        modalId: IdModal.ThemedEventDifficulty,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CoopInvitation] = {
        domComponent: DialogCoopInvitation,
        modalId: IdModal.CoopInvitation,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CoopInvite] = {
        domComponent: DialogCoopInvite,
        modalId: IdModal.CoopInvite,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CoopLeaveConfirm] = {
        domComponent: DialogCoopLeaveConfirm,
        modalId: IdModal.CoopLeaveConfirm,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CoopKick] = {
        domComponent: DialogCoopKick,
        modalId: IdModal.CoopKick,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CoopRoleManagement] = {
        domComponent: DialogCoopRoleManagement,
        modalId: IdModal.CoopRoleManagement,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CoopDemoteLeaderConfirm] = {
        domComponent: DialogDemoteLeaderConfirm,
        modalId: IdModal.CoopDemoteLeaderConfirm,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CoopProjectStartConfirm] = {
        domComponent: DialogCoopProjectStartConfirmation,
        modalId: IdModal.CoopProjectStartConfirm,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CoopProjectStopConfirm] = {
        domComponent: DialogCoopProjectStopConfirmation,
        modalId: IdModal.CoopProjectStopConfirm,
        type: TypeModal.Dialog,
    },
    _a[IdModal.DiscountEvent] = {
        domComponent: DialogDiscountEvent,
        modalId: IdModal.DiscountEvent,
        type: TypeModal.Dialog,
    },
    _a[IdModal.ShopGrowingGoldOffer] = {
        domComponent: DialogShopGrowingOfferInfo,
        modalId: IdModal.ShopGrowingGoldOffer,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CoopProjectCompleted] = {
        domComponent: DialogCoopProjectCompleted,
        modalId: IdModal.CoopProjectCompleted,
        type: TypeModal.Dialog,
    },
    _a[IdModal.PromoteDemote] = {
        domComponent: DialogPromoteDemote,
        modalId: IdModal.PromoteDemote,
        type: TypeModal.Dialog,
    },
    _a[IdModal.LeagueRewardSpecialOffer] = {
        domComponent: DialogLeagueRewardSpecialOffer,
        modalId: IdModal.LeagueRewardSpecialOffer,
        type: TypeModal.Dialog,
    },
    _a[IdModal.ConfirmBuyTournamentSpecialOffer] = {
        domComponent: DialogConfirmBuyTournamentSpecialOffer,
        modalId: IdModal.ConfirmBuyTournamentSpecialOffer,
        type: TypeModal.Dialog,
    },
    _a[IdModal.ShowAllRewardsStore] = {
        domComponent: DialogShowAllRewardsStore,
        modalId: IdModal.ShowAllRewardsStore,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CollectRewardsStore] = {
        domComponent: DialogCollectRewardStore,
        modalId: IdModal.CollectRewardsStore,
        type: TypeModal.Dialog,
    },
    _a[IdModal.CollectReward] = {
        domComponent: DialogCollectReward,
        modalId: IdModal.CollectReward,
        type: TypeModal.Dialog,
    },
    _a[IdModal.EnvSelect] = {
        domComponent: DialogEnvSelect,
        modalId: IdModal.EnvSelect,
        type: TypeModal.Dialog,
    },
    _a[IdModal.PlayerProfilePictureSelection] = {
        domComponent: DialogSelectPlayerProfilePicture,
        modalId: IdModal.PlayerProfilePictureSelection,
        type: TypeModal.Dialog,
    },
    _a[IdModal.PlayerProfilePictureSelectionInfo] = {
        domComponent: DialogSelectPlayerProfilePictureInfo,
        modalId: IdModal.PlayerProfilePictureSelectionInfo,
        type: TypeModal.Dialog,
    },
    _a[IdModal.WebExclusiveReward] = {
        domComponent: DialogWebExclusivePackage,
        modalId: IdModal.WebExclusiveReward,
        type: TypeModal.Dialog,
    },
    _a[IdModal.BalloonOffer] = {
        domComponent: DialogBalloonOffer,
        modalId: IdModal.BalloonOffer,
        type: TypeModal.Dialog,
    },
    // transparent dialog
    _a[IdModal.PendingInventory] = {
        domComponent: DialogPendingInventory,
        modalId: IdModal.PendingInventory,
        type: TypeModal.TransparentDialog,
    },
    _a[IdModal.ThemedEventReward] = {
        domComponent: DialogThemedEventReward,
        modalId: IdModal.ThemedEventReward,
        type: TypeModal.TransparentDialog,
    },
    _a[IdModal.PromoteMobile] = {
        domComponent: PromoteMobile,
        modalId: IdModal.PromoteMobile,
        type: TypeModal.TransparentDialog,
    },
    _a[IdModal.PurchasePointsEvent] = {
        domComponent: DialogPurchasePointsEvent,
        modalId: IdModal.PurchasePointsEvent,
        type: TypeModal.TransparentDialog,
    },
    _a[IdModal.TraderEvent] = {
        domComponent: DialogTraderEvent,
        modalId: IdModal.TraderEvent,
        type: TypeModal.TransparentDialog,
    },
    _a[IdModal.FortuneTellerEvent] = {
        domComponent: DialogFortuneTellerEvent,
        modalId: IdModal.FortuneTellerEvent,
        type: TypeModal.TransparentDialog,
    },
    // Error messages
    _a[IdModal.Maintenance] = {
        domComponent: DialogMaintenance,
        modalId: IdModal.Maintenance,
        type: TypeModal.ErrorDialog,
    },
    _a[IdModal.ManualUpdate] = {
        domComponent: DialogManualUpdate,
        modalId: IdModal.ManualUpdate,
        type: TypeModal.ErrorDialog,
    },
    _a[IdModal.Disconnect] = {
        domComponent: DialogDisconnect,
        modalId: IdModal.Disconnect,
        type: TypeModal.ErrorDialog,
    },
    _a[IdModal.DisconnectedByLogin] = {
        domComponent: DialogDisconnectedByLogin,
        modalId: IdModal.DisconnectedByLogin,
        type: TypeModal.ErrorDialog,
    },
    // Sunsetting
    _a[IdModal.TerminationDialog] = {
        domComponent: DialogSunsetting,
        modalId: IdModal.TerminationDialog,
        type: TypeModal.Dialog,
    },
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/features/modals/modals.ts
// module id = 2549
// module chunks = 3